/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LedgerSourceBreakdownRow
 */
export interface LedgerSourceBreakdownRow {
    /**
     * ContentType of the engagement that granted the points.
     * @type {string}
     * @memberof LedgerSourceBreakdownRow
     */
    attributionType: string;
    /**
     * 
     * @type {string}
     * @memberof LedgerSourceBreakdownRow
     */
    attributionId: string;
    /**
     * The granting engagement's display name; falls back to its type when the document is gone.
     * @type {string}
     * @memberof LedgerSourceBreakdownRow
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof LedgerSourceBreakdownRow
     */
    points: number;
    /**
     * How many grants the engagement produced in the period.
     * @type {number}
     * @memberof LedgerSourceBreakdownRow
     */
    count: number;
}

/**
 * Check if a given object implements the LedgerSourceBreakdownRow interface.
 */
export function instanceOfLedgerSourceBreakdownRow(value: object): value is LedgerSourceBreakdownRow {
    if (!('attributionType' in value) || value['attributionType'] === undefined) return false;
    if (!('attributionId' in value) || value['attributionId'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function LedgerSourceBreakdownRowFromJSON(json: any): LedgerSourceBreakdownRow {
    return LedgerSourceBreakdownRowFromJSONTyped(json, false);
}

export function LedgerSourceBreakdownRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerSourceBreakdownRow {
    if (json == null) {
        return json;
    }
    return {
        
        'attributionType': json['attributionType'],
        'attributionId': json['attributionId'],
        'label': json['label'],
        'points': json['points'],
        'count': json['count'],
    };
}

export function LedgerSourceBreakdownRowToJSON(json: any): LedgerSourceBreakdownRow {
    return LedgerSourceBreakdownRowToJSONTyped(json, false);
}

export function LedgerSourceBreakdownRowToJSONTyped(value?: LedgerSourceBreakdownRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attributionType': value['attributionType'],
        'attributionId': value['attributionId'],
        'label': value['label'],
        'points': value['points'],
        'count': value['count'],
    };
}

